/* global BigInt */
// Use the network's current quote, never Web3's generic multi-gwei default.
export async function getGasFees(web3) {
  try {
    const [block, quoted] = await Promise.all([
      web3.eth.getBlock('latest'), web3.eth.getGasPrice(),
    ]);
    const price = BigInt(quoted);
    if (price <= 0n) throw new Error('Invalid gas quote');
    if (block?.baseFeePerGas == null) return { gasPrice: price.toString() };
    const base = BigInt(block.baseFeePerGas);
    const tip = price > base ? price - base : 0n;
    return {
      maxFeePerGas: (base * 2n + tip).toString(),
      maxPriorityFeePerGas: tip.toString(),
    };
  } catch {
    throw new Error('Could not fetch current network fees. Please retry before sending.');
  }
}
